import React, { Fragment, useState, useEffect, useRef } from "react";
import CopyRight from "../../assets/images/copyRight.svg";
import HumanCopyRight from "../../assets/images/human.svg";
import QuestionMark from "../../assets/images/question.svg";
import downArrow from "../../assets/images/chevron-down.svg";
import BookPlaceHolder from "../../images/bookCover.svg";
import { TagsInput } from "react-tag-input-component";
import { useSelector } from "react-redux";
import { editBook } from "../../Store/api/create";
import { useDispatch } from "react-redux";
import { CustomTooltip } from "../../shared/Tooltip";
const emailPattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

export default function DetailsTab({ book, setBook }) {
  const dispatch = useDispatch();
  const [isEditing, setIsEditing] = useState(false);
  const [materialType, setMaterialType] = useState(false);
  const [license, setLicense] = useState(false);
  const [language, setLanguage] = useState(false);
  const [category, setCategory] = useState(false);
  const [inputValue, setInputValue] = useState("");
  const [errors, setErrors] = useState({});
  const [bookObj, setBookObj] = useState({
    ...book.book,
    iAmAuthor: false,
    authorEmail: "",
  });
  const { user } = useSelector((state) => state.auth);
  const fileInputRef = useRef(null);
  const languageRef = useRef(null);
  const categoryRef = useRef(null);
  const licenseRef = useRef(null);
  const materialTypeRef = useRef(null);
  const { categories, materialTypes, languages, licenses } = useSelector(
    (state) => state.entities.bookFelids.bookFields
  );
  const current_license = licenses.filter(
    (item) => item.label === book.book.license
  )?.[0];

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);
  const handleClickOutside = (event) => {
    if (languageRef.current && !languageRef.current.contains(event.target)) {
      setLanguage(false);
    }
    if (
      materialTypeRef.current &&
      !materialTypeRef.current.contains(event.target)
    ) {
      setMaterialType(false);
    }
    if (categoryRef.current && !categoryRef.current.contains(event.target)) {
      setCategory(false);
    }
    if (licenseRef.current && !licenseRef.current.contains(event.target)) {
      setLicense(false);
    }
  };
  useEffect(() => {
    setBookObj({
      ...book.book,
      iAmAuthor: book.book.authorObj === user._id,
      authorEmail:
        book.book.authorObj === user._id ? user.email : book.book.emailAuthor,
      yearPublished: new Date(book.book.yearPublished).getFullYear().toString(),
    });
  }, [book, user._id]);

  const handleInputChange = (event) => {
    setInputValue(event.target.value);
  };

  const validateBeforeChange = (_, existingTags) => {
    if (existingTags.length > 2) return false;
    return true;
  };

  const handleAddTag = () => {
    if (inputValue.trim() !== "" && bookObj.subjects?.length <= 3) {
      setBookObjField([...bookObj.subjects, inputValue.trim()], "subjects");
      setInputValue("");
    }
  };

  const MaterialTypeToogle = () => {
    setMaterialType(!materialType);
  };

  const setBookObjField = (value, name) => {
    setErrors({});
    setBookObj((old) => ({ ...old, [name]: value }));
    setMaterialType(false);
    setLanguage(false);
    setLicense(false);
    setCategory(false);
  };

  const saveBook = () => {
    let er = false;
    if (!bookObj.title) {
      setErrors((old) => ({ ...old, title: "Title is required." }));
      er = true;
    }
    if (!bookObj.iAmAuthor && !bookObj.authorEmail) {
      setErrors((old) => ({ ...old, authorEmail: "Author is required" }));
      er = true;
    } else if (!emailPattern.test(bookObj.authorEmail)) {
      setErrors((old) => ({
        ...old,
        authorEmail: "Author email should be a valid email.",
      }));
    }
    if (bookObj.collaborator && !emailPattern.test(bookObj.collaborator)) {
      setErrors((old) => ({
        ...old,
        collaborator: "Collaborator email should be a valid email.",
      }));
    }
    if (er) return;
    setErrors({});
    dispatch(
      editBook({
        id: book.book._id,
        body: {
          title: bookObj.title,
          publisher: bookObj.publisher,
          iAmAuthor: bookObj.iAmAuthor,
          authorEmail: bookObj.authorEmail,
          language: bookObj.language,
          materialType: bookObj.materialType,
          categoryType: bookObj.categoryType,
          coverImage: bookObj.coverImage,
          subjects: bookObj.subjects,
          license: bookObj.license,
          isbn: bookObj.isbn,
          yearPublished: new Date(bookObj.yearPublished),
        },
        onSuccess: (res) => {
          setErrors({});
          setBook((old) => ({ ...old, book: { ...res.data.data } }));
          setIsEditing(false);
        },
        onError: (error) => {
          setErrors((old) => ({
            ...old,
            apiError: error.response
              ? error.response.data.message
              : "Something went wrong!",
          }));
        },
      })
    );
  };

  return (
    <div className="details_wrap">
      {!isEditing ? (
        <Fragment>
          <div className="class_room_box" style={{ marginTop: 24 }}>
            <div className="class_room_img">
              <img
                src={book.book.coverImage || book.book?.bookDetailCoverUrl || BookPlaceHolder}
                alt="class_rom_img"
                className="class_rom_img"
                width={114}
                height={154}
                style={{ objectFit: "fill" }}
              />
            </div>
            <div className="class_room_content pdl-20">
              <div className="content_top">
                <h5>{book.book.title}</h5>
                <p>Written by: {book.book.author}</p>
                <p>{new Date(book.book.createdAt).getFullYear()}</p>
                <div className="copy_rights">
                  <img src={CopyRight} alt="copyrights" />
                  <img src={HumanCopyRight} alt="lisence" />
                </div>
              </div>
            </div>
          </div>
          <div className="textbook-container">
            <div className="breadcrumb">{`${
              book.book.categoryType
            } / ${book.book?.subjects?.join(", ")}`}</div>
            <h1>{book.book.title}</h1>
            <div className="details">
              <p>
                Written by: <span>{book.book.author}</span>
              </p>
              <p>
                Year published: <span>{bookObj.yearPublished}</span>
              </p>
              <p>
                Publisher: <span>{book.book.publisher || "--"}</span>
              </p>
              <p>
                Language: <span>{book.book.language || "--"}</span>
              </p>
              <p>
                Material: <span>{book.book.materialType}</span>
              </p>
              <p>
                ISBN: <span>{book.book?.isbn || "--"}</span>
              </p>
            </div>
            <div className="conditions-of-use">
              <p>Conditions of Use</p>
              <div className="licenses">
                {current_license?.img_url && (
                  <img src={current_license.img_url} alt="CC" />
                )}
                {current_license?.img_url2 && (
                  <img src={current_license.img_url2} alt="BY" />
                )}
                {current_license?.img_url3 && (
                  <img src={current_license.img_url3} alt="NC" />
                )}
                <p>
                  <u>Attribution-NonCommercial</u>
                  <br />
                  {current_license?.label || "CC BY-NC"}
                </p>
              </div>
            </div>
            <div className="actions w-100">
              <button
                className="edit-details w-100"
                onClick={() => {
                  setIsEditing(true);
                }}
              >
                Edit details
              </button>
              <button className="book-management w-100">Book Management</button>
            </div>
          </div>
        </Fragment>
      ) : (
        <Fragment>
          <form
            action=""
            className="create_new_book"
            onSubmit={(e) => {
              e.preventDefault();
            }}
          >
            <div
              style={{
                marginTop: "24px",
                padding: "0px 64px 32px 64px",
              }}
            >
              <img
                src={bookObj.coverImage || bookObj?.bookDetailCoverUrl || BookPlaceHolder}
                alt=""
                width={114}
                height={154}
                style={{ objectFit: "fill" }}
              />
              <button
                style={{
                  marginLeft: "45px",
                  padding: "12px",
                  background: "white",
                  borderRadius: 4,
                  border: "1px solid black",
                  fontSize: "14px",
                }}
                onClick={() => {
                  fileInputRef.current.click();
                }}
              >
                Upload image
              </button>
              <input
                type="file"
                style={{ display: "none" }}
                ref={fileInputRef}
                accept="image/*"
                onChange={(e) => {
                  const imgFile = e.target.files[0];
                  const reader = new FileReader();

                  reader.onload = (event) => {
                    const img = new Image();
                    img.src = event.target.result;

                    img.onload = () => {
                      const canvas = document.createElement("canvas");
                      const ctx = canvas.getContext("2d");

                      const maxWidth = 124; // desired width
                      const maxHeight = 160; // desired height

                      let width = img.width;
                      let height = img.height;

                      // Calculate the new dimensions while maintaining the aspect ratio
                      if (width > height) {
                        if (width > maxWidth) {
                          height *= maxWidth / width;
                          width = maxWidth;
                        }
                      } else {
                        if (height > maxHeight) {
                          width *= maxHeight / height;
                          height = maxHeight;
                        }
                      }

                      canvas.width = width;
                      canvas.height = height;

                      // Draw the image on the canvas
                      ctx.drawImage(img, 0, 0, width, height);

                      // Get the data URL of the resized image
                      const imgDataUrl = canvas.toDataURL("image/jpeg", 1); // quality factor between 0 and 1

                      // Update the state with the resized image data
                      setBookObj((old) => ({ ...old, coverImage: imgDataUrl }));
                    };
                  };

                  if (imgFile) {
                    reader.readAsDataURL(imgFile);
                  }
                }}
              />
            </div>
            <div className="form-group mb-45">
              <input
                type="text"
                className="form-control pl_0"
                name="title"
                placeholder="Title"
                value={bookObj.title}
                onChange={(e) => {
                  setBookObjField(e.target.value, e.target.name);
                }}
              />
              {errors.title && (
                <span className="error-create">{errors.title}</span>
              )}
            </div>
            <div className="form-group mb-45">
              <div
                className="select_wrap_create"
                style={{ width: "90%" }}
                ref={categoryRef}
              >
                <div
                  className={`cursor_pointer m-0 form-control pl_0 custom_select_create text-grey-create mb-0 d-flex justify-content-between ${
                    category ? "open" : ""
                  }`}
                  onClick={() => {
                    setCategory((old) => !old);
                  }}
                >
                  {bookObj.categoryType ? bookObj.categoryType : "Category"}
                  {!category && <img src={downArrow} alt="ico here" style={{ marginRight: "10px" }} />}
                </div>
                {category && (
                  <div
                    className="drop_down_list_create"
                    style={{ display: "block" }}
                  >
                    <ul>
                      {categories.map((category, index) => (
                        <li
                          key={index}
                          style={{
                            display: `${
                              bookObj.categoryType === category ? "none" : ""
                            }`,
                          }}
                          onClick={() => {
                            setBookObjField(category, "categoryType");
                          }}
                        >
                          {category}
                        </li>
                      ))}
                    </ul>
                  </div>
                )}
              </div>
              <span className="error-create" style={{ display: "none" }}>
                please select title
              </span>
            </div>
            <div className="form-group mb-45">
              <div className="add_value_wrap-create">
                <div className="add_vlue_input_tage">
                  <TagsInput
                    value={bookObj.subjects}
                    onChange={(e) => {
                      setBookObjField(e, "subjects");
                    }}
                    name="fruits"
                    autoComplete="off"
                    placeHolder={
                      bookObj?.subjects?.length
                        ? ""
                        : "Subject tags (add one at a time)"
                    }
                    className="form-control pl_0"
                    onKeyUp={handleInputChange}
                    beforeAddValidate={validateBeforeChange}
                  />
                  <span className="add_tages">
                    {bookObj?.subjects?.length}/3
                  </span>
                </div>
                <button
                  type="button"
                  className="add_btn_value_create"
                  onClick={handleAddTag}
                  disabled={bookObj.subjects?.length >= 3} // Disable button when the tag count reaches 3
                >
                  Add
                </button>
              </div>
            </div>
            <div className="form-group mb-45">
              <div className="author_fname">
                <div className="author_f_img">
                  {user?.image ? (
                    <img
                      src={user?.image}
                      className="user_img_cre"
                      alt="author"
                    />
                  ) : (
                    <div
                      className="profilePicture"
                      style={{ fontSize: "16px" }}
                    >
                      {user?.firstName?.[0]}
                      {user?.lastName?.[0]}
                    </div>
                  )}
                </div>
                <div className="checkbox-wrapper-create">
                  <input
                    id="cbx-42"
                    type="checkbox"
                    checked={bookObj.iAmAuthor}
                    onChange={(e) => {
                      if (e.target.checked) {
                        setErrors((old) => ({ ...old, authorEmail: "" }));
                      }
                      setBookObj((old) => ({
                        ...old,
                        iAmAuthor: e.target.checked,
                        authorEmail: e.target.checked ? user.email : "",
                      }));
                    }}
                  />
                  <label className="cbx" htmlFor="cbx-42"></label>
                  <label className="lbl" htmlFor="cbx-42">
                    I am the author
                  </label>
                </div>
              </div>
              <input
                type="email"
                value={bookObj.authorEmail}
                readOnly={bookObj.iAmAuthor}
                onChange={(e) => {
                  setBookObjField(e.target.value, e.target.name);
                }}
                name="authorEmail"
                className="form-control pl_0"
                placeholder="Add the original author(s) by email"
              />
              {errors.authorEmail && (
                <span className="error-create">{errors.authorEmail}</span>
              )}
            </div>
            <div className="form-group mb-45">
              <input
                type="email"
                className="form-control pl_0"
                placeholder="Invite a collaborator by email"
                value={bookObj.collaborator}
                name="collaborator"
                onChange={(e) => {
                  setBookObjField(e.target.value, e.target.name);
                }}
              />
              {errors.collaborator && (
                <span className="error-create">{errors.collaborator}</span>
              )}
            </div>
            <div className="form-group position-relative mb-45">
              <input
                type="text"
                className="form-control pl_0"
                placeholder={"Year published"}
                value={bookObj.yearPublished}
                name="yearPublished"
                onChange={(e) => {
                  setBookObjField(e.target.value, e.target.name);
                }}
              />
              <CustomTooltip content="Enter the year the book was published.">
                <span className="position-absolute top-50 end-0 translate-middle-y me-2">
                  <img src={QuestionMark} alt="icon" className="svg-icon" />
                </span>
              </CustomTooltip>
            </div>
            <div className="form-group position-relative mb-45">
              <input
                type="text"
                className="form-control pl_0"
                placeholder={"Published"}
                value={bookObj.publisher}
                name="publisher"
                onChange={(e) => {
                  setBookObjField(e.target.value, e.target.name);
                }}
              />
              <CustomTooltip content="Enter the location or website that it was published by.">
                <span className="position-absolute top-50 end-0 translate-middle-y me-2">
                  <img src={QuestionMark} alt="icon" className="svg-icon" />
                </span>
              </CustomTooltip>
            </div>
            <div className="form-group mb-45">
              <div
                className="select_wrap_create"
                style={{ width: "90%" }}
                ref={materialTypeRef}
              >
                <div
                  className={`cursor_pointer m-0 form-control pl_0 custom_select_create text-grey-create mb-0 d-flex justify-content-between ${
                    materialType ? "open" : ""
                  }`}
                  onClick={MaterialTypeToogle}
                >
                  {bookObj.materialType
                    ? bookObj.materialType
                    : "Material type"}
                  {!materialType && <img src={downArrow} alt="ico here" style={{ marginRight: "10px" }} />}
                </div>
                {materialType && (
                  <div
                    className="drop_down_list_create"
                    style={{ display: "block" }}
                  >
                    <ul>
                      {materialTypes.map((material, index) => (
                        <li
                          key={index}
                          style={{
                            display: `${
                              bookObj.materialType === material ? "none" : ""
                            }`,
                          }}
                          onClick={() => {
                            setBookObjField(material, "materialType");
                          }}
                        >
                          {material}
                        </li>
                      ))}
                    </ul>
                  </div>
                )}
              </div>
              <span className="error-create" style={{ display: "none" }}>
                please select title
              </span>
            </div>

            <div className="form-group mb-45">
              <div
                className="select_wrap_create"
                style={{ width: "90%" }}
                ref={languageRef}
              >
                <div
                  className={`cursor_pointer m-0 form-control pl_0 custom_select_create text-grey-create mb-0 d-flex justify-content-between ${
                    language ? "open" : ""
                  }`}
                  onClick={() => {
                    setLanguage((old) => !old);
                  }}
                >
                  {bookObj.language ? bookObj.language : "Language"}
                  {!language && <img src={downArrow} alt="ico here" style={{ marginRight: "10px" }} />}
                </div>
                {language && (
                  <div
                    className="drop_down_list_create"
                    style={{ display: "block" }}
                  >
                    <ul>
                      {languages.map((language, index) => (
                        <li
                          key={index}
                          style={{
                            display: `${
                              bookObj.language === language ? "none" : ""
                            }`,
                          }}
                          onClick={() => {
                            setBookObjField(language, "language");
                          }}
                        >
                          {language}
                        </li>
                      ))}
                    </ul>
                  </div>
                )}
              </div>
              <span className="error-create" style={{ display: "none" }}>
                please select title
              </span>
            </div>
            <div className="form-group position-relative mb-45">
              <input
                type="text"
                className="form-control pl_0"
                placeholder={"ISBN"}
                value={bookObj.isbn}
                name="isbn"
                onChange={(e) => {
                  setBookObjField(e.target.value, e.target.name);
                }}
              />
              <CustomTooltip content="If your book does not have ISBN, then leave it blank. One will be provided to you by Greyled.">
                <span className="position-absolute top-50 end-0 translate-middle-y me-2">
                  <img src={QuestionMark} alt="icon" className="svg-icon" />
                </span>
              </CustomTooltip>
            </div>
            <div className="form-group mb-45">
              <div className="select_wrap_create" ref={licenseRef}>
                {license && (
                  <div
                    className="drop_down_list_create"
                    style={{
                      display: "block",
                      width: "90%",
                      bottom: "51px",
                      borderBottomLeftRadius: "0px",
                      borderBottomRightRadius: "0px",
                    }}
                  >
                    <ul>
                      {licenses.map((license, index) => (
                        <li
                          className={`${
                            bookObj.license === license.label
                              ? "active_option_state"
                              : ""
                          }`}
                          key={index}
                          onClick={() => {
                            setBookObjField(license.label, "license");
                            setLicense(false);
                          }}
                        >
                          <div className="d-flex justify-content-between align-items-center">
                            <div className="d-flex" style={{ gap: "14px" }}>
                              <span>{license.label}</span>
                              <div className="d-flex" style={{ gap: "8px" }}>
                                {license.img_url && (
                                  <img
                                    src={license.img_url}
                                    width={22}
                                    height={22}
                                    alt="license icons here"
                                  />
                                )}
                                {license.img_url2 && (
                                  <img
                                    src={license.img_url2}
                                    width={22}
                                    height={22}
                                    alt="license icons here"
                                  />
                                )}
                                {license.img_url3 && (
                                  <img
                                    src={license.img_url3}
                                    width={22}
                                    height={22}
                                    alt="license icons here"
                                  />
                                )}
                              </div>
                            </div>
                            <a
                              href={license.linkTo}
                              target="_blank"
                              rel="noreferrer"
                              referrerPolicy="no-referrer"
                            >
                              <img
                                src="/assets/images/external_link.svg"
                                width={22}
                                height={22}
                                alt="external_link"
                              />
                            </a>
                          </div>
                        </li>
                      ))}
                    </ul>
                  </div>
                )}
                <div
                  className={`cursor_pointer m-0 form-control pl_0 custom_select_create text-grey-create custom-border-bottom d-flex justify-content-between ${
                    license ? "open": ""
                  }`}
                  style={{ width: "90%" }}
                  onClick={() => {
                    setLicense((old) => !old);
                  }}
                >
                  {bookObj.license || "License"}
                  {!license && <img src={downArrow} alt="ico here" style={{ marginRight: "10px", transform:  "rotate(180deg)"}} />}
                </div>
              </div>
              <span className="error-create" style={{ display: "none" }}>
                please select title
              </span>
            </div>
            <div className="actions w-100">
              {errors.apiError && (
                <span className="error-create w-100">{errors.apiError}</span>
              )}
              <button className="edit-details w-100" onClick={saveBook}>
                Save details
              </button>
              <button
                className="book-management w-100"
                onClick={() => {
                  setIsEditing(false);
                }}
              >
                Cancel
              </button>
            </div>
          </form>
        </Fragment>
      )}
    </div>
  );
}
